import MetricsTable from "../MetricsTable/MetricsTable";
import { chart_contentBehaviour } from "../../connections";
import {useEffect, useState} from "react";

interface TableData {
    page_name: string;
    total_page_visits: number;
    unique_learners_count: number;
    avg_time: number;
    abandoned_page_count:number;
}
type ApiResponse = { data: TableData[] };
export default function ContentBehaviourTable() {
    const [data, setData] = useState<string[][]>([])
    useEffect(() => {
        const getData = async () => {
            const response: ApiResponse = await chart_contentBehaviour();
            const stringValues: string[][] = response.data.map(item => [
                item.page_name,
                item.total_page_visits.toString(),
                item.unique_learners_count.toString(),
                (Math.round(item.avg_time / 1000)).toString() + "s",
                item.abandoned_page_count.toString()
            ]);
            setData(stringValues);
        }
        getData();
    }, []);
    return (
        <MetricsTable
            title="What were the learner behaviours within the content?"
            headers={["Page Name","Total Page Visits", "Number of\n Unique Learners","Average Time on\na Page (in seconds)","Number of \n Page Abandoned"]}
            data={data}
            table_width="100%"
        />
    )
}